import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8080/api";

const onboardingClient = axios.create({
  baseURL: API_URL,
});

export type ValidateTokenResponse = { valid: boolean; clientName: string };

export type OnboardingSalespersonPayload = {
  name: string;
  email: string;
  temporaryPassword: string;
  permissions: string[];
};

export type OnboardingRegisterPayload = {
  token: string;
  dealershipName: string;
  cnpj: string;
  ownerEmail: string;
  ownerPassword: string;
  confirmarSenha: string;
  salespeople?: OnboardingSalespersonPayload[];
};

export type OnboardingRegisterResponse = {
  token: string;
  nome: string;
  email: string;
  role: string;
  id: string;
  concessionariaNome?: string;
  concessionariaId?: string;
};

export const onboardingService = {
  validateInviteToken: async (
    token: string
  ): Promise<ValidateTokenResponse> => {
    const { data } = await onboardingClient.post<ValidateTokenResponse>(
      "/onboarding/validate-token",
      { token }
    );
    return data;
  },

  registerWithInviteToken: async (
    payload: OnboardingRegisterPayload
  ): Promise<OnboardingRegisterResponse> => {
    const { data } = await onboardingClient.post<OnboardingRegisterResponse>(
      "/onboarding/register",
      payload
    );
    return data;
  },
};
